
/**
 * Constants for React Query configuration
 */

// Cache configuration
export const STALE_TIME = 1000 * 60 * 5;  // 5 minutes
export const GC_TIME = 1000 * 60 * 30;    // 30 minutes (replaces deprecated cacheTime)

// Retry configuration
export const RETRY_COUNT = 3;              // Number of retry attempts
export const RETRY_DELAY = 1000;           // Base delay between retries (1 second)
export const MAX_RETRY_DELAY = 30000;      // Maximum retry delay of 30 seconds

/**
 * Calculates exponential backoff delay for retries
 */
export const getRetryDelay = (attemptIndex: number) => Math.min(
  // Exponential backoff: 1s, 2s, 4s, etc. up to 30s max
  RETRY_DELAY * Math.pow(2, attemptIndex),
  MAX_RETRY_DELAY
);
